<div class="row mb-2">
  <div class="col">
  </div>
    <div class="col text-center">
    <h3>CRIME LOG</h3>
  </div>
  <div class="col text-right">
    <button *ngIf="checkPermissions()" type="button" class="btn btn-primary mr-1" (click)="openAddLog()">Add Crime Report</button>
    <button *ngIf="checkPermissions()" type="button" class="btn btn-danger mr-1" (click)="openDeleteLog()">Delete Crime Reports</button><br>
    <button *ngIf="checkPermissions()" type="button" class="btn btn-info mt-1 mr-1" (click)="getExcel()">Excel</button>
    <a [routerLink]="['/firelog']"><button type="button" class="btn btn-info mt-1 mr-1"><fa-icon [icon]="faFire"></fa-icon> View Fire Log</button></a>
  </div>
</div>

<div style="display: flex; flex-direction: row">
  <div style="flex-grow: 1; height:600px;">
    <ag-grid-angular
        style="height:100%;"
        class="ag-theme-balham"
        [rowSelection]="rowSelection"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        (selectionChanged)="onSelectionChanged($event)"
        (gridReady)="onGridReady($event)"
        >
    </ag-grid-angular>
  </div>
</div>
